import {datePlugin} from '@/core/plugins/dates';

/**
 * @param {[string, string]} workedTime
 * @return {boolean}
 */
export const checkWorkTime = ([startTime, endTime]) => {
    if (!startTime || !endTime) {
        return false;
    }

    const dateFormat = 'YYYY-MM-DD HH:mm';
    const nowDate = datePlugin().format('YYYY-MM-DD');
    const startDate = datePlugin(`${nowDate} ${startTime}`, dateFormat).format(dateFormat);
    const endDate = datePlugin(`${nowDate} ${endTime}`, dateFormat).format(dateFormat);

    return datePlugin().isBetween(startDate, endDate, 'minutes', '[)');
};
